<template>
  <div :class="`add-file-block${showMenu ? ' add-file-active' : ''}`" v-if="!isDisabled">
    <div class="add-file-btn">
      <el-dropdown
            trigger="click"
            placement="start"
            @visible-change='dropdownChange'
            :hide-on-click="false"
            ref="messageDrop">
            <div>
                <span @click="toogleMenu" class="btn-tip" v-cloak :title="$t('New')">{{$t('New')}}</span>
                <span @click="toogleMenu" :class="`add-file-btn-icon ${showMenu ? 'add-rotate' : ''}`">
                    <i class="components-icons components-icons-close">
                        <span class="path1"></span>
                    </i>
                </span>
            </div>

          <el-dropdown-menu slot="dropdown" class='affix'>
            <el-dropdown-item>
                <div class="el-dropdown-menu__item-block" @click="handleAction('doc')">
                    <i class="components-icons components-icons-doc-m"><span class="path1"></span><span class="path2"></span></i>
                    <span v-cloak :title="$t('Newdoc')">{{$t('Newdoc')}}</span>
                </div>
            </el-dropdown-item>
            <el-dropdown-item>
                <div class="el-dropdown-menu__item-block" @click="handleAction('xls')">
                    <i class="components-icons components-icons-xls-m"><span class="path1"></span><span class="path2"></span></i>
                    <span v-cloak :title="$t('Newxls')">{{$t('Newxls')}}</span>
                </div>
            </el-dropdown-item>
            <el-dropdown-item>
                <div class="el-dropdown-menu__item-block" @click="handleAction('ppt')">
                    <i class="components-icons components-icons-ppt-m"><span class="path1"></span><span class="path2"></span></i>
                    <span v-cloak :title="$t('Newppt')">{{$t('Newppt')}}</span>
                </div>
            </el-dropdown-item>
            <el-dropdown-item divided>
                <div class="el-dropdown-menu__item-block" @click="handleAction('folder')">
                    <i class="components-icons components-icons-add-folder"><span class="path1"></span><span class="path2"></span></i>
                    <span v-cloak :title="$t('Newfolder')">{{$t('Newfolder')}}</span>
                </div>
            </el-dropdown-item>
            <el-dropdown-item divided >
                <el-popover trigger="hover" v-model="moreListShow" placement="left" offset="6" :visible-arrow="false" ref="moreList" popper-class="more-list">
                    <label for="upbtn" @click="closeUp('file')">
                        <div class="el-dropdown-menu__item" @mouseover="SET_UPLOADTYPE({type:false})">
                            <div class="el-dropdown-menu__item-block">
                                <i class="components-icons components-icons-upload-file-s"><span class="path1"></span></i>
                                <span v-cloak :title="$t('Upfile')">{{$t('Upfile')}}</span>
                            </div>
                        </div>
                    </label>
                    <label for="upbtn" @click="closeUp('folder')">
                        <div class="el-dropdown-menu__item" @mouseover="SET_UPLOADTYPE({type:true})">
                            <div class="el-dropdown-menu__item-block">
                                <i class="components-icons components-icons-add-folder"><span class="path1"></span><span class="path2"></span></i>
                                <span v-cloak :title="$t('Upfolder')">{{$t('Upfolder')}}</span>
                            </div>
                        </div>
                    </label>
                    <div class="el-dropdown-menu__item-block" slot="reference">
                        <i class="components-icons components-icons-upload"><span class="path1"></span><span class="path2"></span></i><span class="path1"></span><span class="path2"></span>
                        <span v-cloak :title="$t('Upload')">{{$t('Upload')}}</span>
                        <i class="components-icons components-icons-chevronright upload-right-arrow"><span class="path1"></span></i>
                    </div>
                </el-popover>
            </el-dropdown-item>
          </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState, mapActions} from 'vuex'
export default {
    data(){
        return {
            showMenu: false,
            moreListShow: false
        }
    },
    mounted(){
        if(window.cefQuery){
            window.flushFiles = () => {
                if(this.parentid || this.$route.name == 'index' || this.route == 'teams'){
                    this.flush(this.parentid)
                    this.route == 'teams' ? this.flushEvents({noinit: true}) : ''
                }
            }
        }
    },
    computed:{
        ...mapState([
            'group',
            'parentid',
            'route'
        ]),
        ...mapState('team',[
            'currentTeam'
        ]),
        isDisabled(){
            return this.currentTeam.member_role == 'read_member'
        }
    },
    methods:{
        ...mapMutations([
            'SHOW_DIALOG',
            'SET_UPLOADTYPE'
        ]),
        ...mapActions('index',[
            'flush'
        ]),
        ...mapActions('events',{
            flushEvents: 'flush'
        }),
        dropdownChange (v) {
            this.showMenu = v
        },
        toogleMenu (e) {
            this.showMenu = !this.showMenu                
        },
        upload(){
            this.moreListShow = false
        },
        handleAction(ftype){
            this.$refs.messageDrop.hide()
            this.SHOW_DIALOG({
                current: 'create',
                title: ftype == 'folder' ? this.$t('Newfolder') : this.$tc('Newfile'),
                action: ftype
            })
        },
        closeUp(type){
            if (type) {
                _dw.onEvent(`drive_upload_${type}`)
            }
            if(window.cefQuery){
                let {tid} = this.$route.params
                let groupid = tid || this.group
                let parentid = parseInt(this.parentid)
                let isfolder = type == 'folder'
                wpsApi({method: 'jsFileUpload',params:{
                    groupid,
                    parentid,
                    isfolder
                }},function(res){
                    console.log(res)
                })
            }
            this.$refs.moreList.doClose()
        }
    }
}
</script>

<style>
.add-file-block{
    position: absolute;
    right: 40px;
    bottom: 30px;
    z-index: 2;
}
.add-file-block.add-file-active{
    z-index: 2001;
}
.btn-tip{
    background: #FFFFFF;
    box-shadow: 0 2px 8px 0 rgba(98, 107, 132, 0.15);
    border-radius: 2px;
    position: absolute;
    padding: 0 4px;
    right: 86px;
    white-space: nowrap;
    height: 28px;
    outline: none;
    text-align: center;
    line-height: 28px;
    top: -45px;
    cursor: pointer;
}
.add-file-block .add-file-btn-icon {
    position: absolute;
    right: 3px;
    bottom: 3px;
    width: 60px;
    height: 60px;
    line-height: 60px;
    border-radius: 50%;
    background: #f8d61d;
    color: #fff;
    cursor: pointer;
    z-index: 3;
    box-shadow: 0 2px 6px 0 hsla(0,0%,74%,.54), inset 0 -1px 0 0 #eecd15;
}
.add-file-btn-icon .components-icons {
    font-size: 23px;
    font-weight: 700;
    display: block;
    line-height: 60px;
    transition: all .2s ease-in;
    text-align: center;
    transform: rotate(-45deg);
}
.add-rotate.add-file-btn-icon .components-icons{
    transform: rotate(0);
}
.el-dropdown-menu.affix{
    position: fixed;
    border-radius: 2px;
    bottom: 110px !important;
    right: 24px !important;
    left: auto !important;
    top: auto !important;
    padding: 16px;
    font-size: 14px;
}
.el-dropdown-menu.affix .el-dropdown-menu__item,.more-list .el-dropdown-menu__item{
    line-height: 36px;
    padding: 0;
    margin-bottom: 8px;
}
.el-dropdown-menu__item-block{
    padding-left: 42px;
    position: relative;
    color: #626b84;
    white-space: nowrap;
}
.el-dropdown-menu.affix .components-icons,.more-list .components-icons{
    font-size: 20px;
    position: absolute;
    left: 10px;
    bottom: 8px;
}
.el-dropdown-menu.affix .el-dropdown-menu__item:not(.is-disabled):hover{
    background: #f7f9fc;
    color: #626b84;
}
.upload-right-arrow{
    right: 10px;
    left: inherit!important;
}
.more-list{
    margin-right: 22px!important;
    padding: 0 4px;
    padding-top: 8px;
}
.more-list .components-icons{
    color: #2e68f8;
}
</style>


// WEBPACK FOOTER //
// src/components/uploader/Affix.vue